import { render, staticRenderFns } from "./pageStudentMessage.vue?vue&type=template&id=aa1347b4&scoped=true"
import script from "./pageStudentMessage.vue?vue&type=script&lang=js"
export * from "./pageStudentMessage.vue?vue&type=script&lang=js"
import style0 from "./pageStudentMessage.vue?vue&type=style&index=0&id=aa1347b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1347b4",
  null
  
)

export default component.exports